import { render, staticRenderFns } from "./InfoButton.vue?vue&type=template&id=2f7f9413&scoped=true&"
import script from "./InfoButton.vue?vue&type=script&lang=ts&"
export * from "./InfoButton.vue?vue&type=script&lang=ts&"
import style0 from "./InfoButton.vue?vue&type=style&index=0&id=2f7f9413&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7f9413",
  null
  
)

export default component.exports